// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// <user>
export class MicrosoftUser {
  displayName!: string;
  email!: string;
  avatar!: string;
  timeZone!: string;
}
// </user>
